module.exports = "<h2>User info</h2>\r\n<h5>Token</h5>\r\n<pre>\r\n\t{{token | json }}\r\n</pre>\r\n";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shell/user-details.component.html
// module id = 442
// module chunks = 10